import instance from './instance'

const catalogueUrl = 'modules-lead/catalogues'

export const getCatalogueList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${catalogueUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)

export const getCatalogueById = (id: number) => instance.get(`${catalogueUrl}/${id}`)

export const createCatalogue = (payload: any) => instance.post(catalogueUrl, payload)

export const updateCatalogue = (id: any, payload: any) =>
  instance.post(`${catalogueUrl}/${id}`, payload)

export const deleteCatalogue = async (id: number) =>
  await instance.delete(`${catalogueUrl}/${id}`)
